export enum StepLabel {
    VoucherBaseInfo = 'Voucher Base Info',
    VoucherDisplayInfo = 'Voucher Display',
    VoucherDetails = 'Voucher Details',
    VoucherConditions = 'Voucher Conditions',
    VoucherSummary = 'Voucher Summary',
    OfferBaseInfo = 'Offer Base Info',
    OfferDisplayInfo = 'Offer Display',
    OfferDetails = 'Offer Details',
    OfferVoucherBaseInfo = 'Reward Base Info',
    OfferVoucherDisplayInfo = 'Reward Display',
    OfferVoucherDetails = 'Reward Details',
    OfferVoucherConditions = 'Reward Conditions',
    OfferConditions = 'Offer Condition',
    OfferSummary = 'Offer Summary',
    LoyaltyDisplayInfo = 'Loyalty Display',
    LoyaltyDetails = 'Loyalty Details',
    LoyaltyConditions = 'Loyalty Conditions',
    LoyaltySummary = 'Loyalty Summary',
    LoyaltyReward = 'Reward',
    LuckyDrawBaseInfo = 'Lucky Draw Base Info',
    LuckyDrawDisplayInfo = 'Lucky Draw Display',
    LuckyDrawDetails = 'Lucky Draw Details',
    LuckyDrawReward = 'Lucky Draw Reward',
    LuckyDrawConditions = 'Lucky Draw Conditions',
    LuckyDrawSummary = 'Lucky Draw Summary'
}
export interface Step {
    label: StepLabel;
    action?: () => void;
}

export const promoSteps = [
    { label: StepLabel.VoucherBaseInfo },
    { label: StepLabel.VoucherDisplayInfo },
    { label: StepLabel.VoucherDetails },
    { label: StepLabel.VoucherConditions },
    { label: StepLabel.VoucherSummary }
];

export const luckyDrawSteps = [
    { label: StepLabel.LuckyDrawBaseInfo },
    { label: StepLabel.LuckyDrawDisplayInfo },
    { label: StepLabel.LuckyDrawDetails },
    { label: StepLabel.LuckyDrawReward },
    { label: StepLabel.LuckyDrawConditions },
    { label: StepLabel.LuckyDrawSummary }
];

export const loyaltySteps = [
    { label: StepLabel.LoyaltyDisplayInfo },
    { label: StepLabel.LoyaltyDetails },
    { label: StepLabel.LoyaltyConditions },
    { label: StepLabel.LoyaltyReward },
    { label: StepLabel.LoyaltySummary }
];

export const offerSteps = [
    { label: StepLabel.OfferBaseInfo },
    { label: StepLabel.OfferDisplayInfo },
    { label: StepLabel.OfferDetails },
    { label: StepLabel.OfferConditions },
    { label: StepLabel.OfferVoucherBaseInfo },
    { label: StepLabel.OfferVoucherDisplayInfo },
    { label: StepLabel.OfferVoucherDetails },
    { label: StepLabel.OfferVoucherConditions },
    { label: StepLabel.OfferSummary }
];

export const createSteps = (isOffer: boolean, isLoyalty: boolean, isLuckyDraw: boolean): Step[] => {
    if (isLuckyDraw) {
        return luckyDrawSteps;
    }

    if (isLoyalty) {
        return loyaltySteps;
    }
    if (isOffer && !isLoyalty) {
        return offerSteps;
    }
    return promoSteps;
};
